import MyProfileImg from '@/components/my/common/item/MyProfileImg';
import {goToChannelViaAppScheme} from '@/components/starrank/mobile/StarRankMobileLayout';
import {convertViewCnt} from '@/utils/main';

/**
 * 별별랭킹 모바일 페이지, 방송 아이템 정보(닉네임, 시청 수) 영역
 */
const StarRankMobileBroadDetailMenu = ({rankItem}) => {
  return (
    <div className='detail'>
      <a
        className='thumb'
        onClick={() => goToChannelViaAppScheme(rankItem?.userId)}>
        <MyProfileImg userId={rankItem?.userId} disableLay={true} />
      </a>
      <a
        className='nick'
        onClick={() => goToChannelViaAppScheme(rankItem?.userId)}>
        {rankItem?.userNick}
      </a>
      <span className='view'>
        <em>{convertViewCnt(rankItem?.totalViewCnt)}</em>
      </span>
    </div>
  );
};

export default StarRankMobileBroadDetailMenu;
